export default "__VITE_ASSET__CA5rllbg__"